import { render, staticRenderFns } from "./simulator-operations-table.vue?vue&type=template&id=648a8492&"
import script from "./simulator-operations-table.vue?vue&type=script&lang=js&"
export * from "./simulator-operations-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VDataTable,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('648a8492')) {
      api.createRecord('648a8492', component.options)
    } else {
      api.reload('648a8492', component.options)
    }
    module.hot.accept("./simulator-operations-table.vue?vue&type=template&id=648a8492&", function () {
      api.rerender('648a8492', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/portfolio-review/components/simulator-operations-table/simulator-operations-table.vue"
export default component.exports